import { set } from "../../../../components/chart/chart-color";
import warehousepurchaseFullcont  from "./warehousepurchase-fullcont.html";

const dialog              = require ('../../../../components/dialog/dialog')
const signature              = require ('../../../../components/signature/signature')
const settings            = require('../../../../js-handler/settings')
const fullcontEntity      = require ('../../../../components/fullcont/fullcont-entity')
const fullcontHandler     = require ('../../../../components/fullcont/fullcont-handler')
const warehousepurchaseDt          = require('./warehousepurchase-dt')
// const warehousepurchaseMenu        = require('./warehousepurchase-menu')
const {formCopy}          = require('./warehousepurchase-fullcont-form') 
const {form}              = require('./warehousepurchase-fullcont-form')
// const {warehousepurchaseMT}        = require('./warehousepurchase-fullcont-multitable')
const warehousepurchaseMT   = undefined //no MT just add this like undefined

/****************ELEMENTS*****************/
var htmlFc          = {}
var HTMLwasSelected = false

//console.log("111111====", warehousepurchaseFullcont)

function HTMLselect(detail){ 

	fullcontHandler.HTMLselect(

            'purchase', //database table name****
            'warehousepurchase', //dest entity on js
            'warehousepurchase-fullcont', 
            warehousepurchaseFullcont, form, formCopy, warehousepurchaseMT, 
             editDialog, deleteDialog, dtCall, htmlFc)


	HTMLwasSelected   = true  

      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc)
}/**/


export function start(detail){  //console.log('warehousepurchase-dt 5>', warehousepurchaseMT)
      
      if(!HTMLwasSelected) { HTMLselect(detail) }
      
      obj[detail.act].start(detail)
}/**/

const obj = {
      addOne:           { start: (detail)=>{  addOne(detail, htmlFc)                                   }},
      cancelEdit:       { start: (detail)=>{  fullcontEntity.cancelEdit(detail, htmlFc)                }},
      deleteEntity:     { start: (detail)=>{  fullcontEntity.deleteEntity(detail, htmlFc)              }},
      deleteFromDialog: { start: (detail)=>{  deleteFromDialog(detail, htmlFc)                         }},
      discard:          { start: (detail)=>{  fullcontHandler.discard(detail, htmlFc)                  }},
      // fullcontOptions:  { start: (detail)=>{  warehousepurchaseMenu.start(detail, 'htmlDt', htmlFc )                }},
      hide:             { start: (detail)=>{  fullcontEntity.hide(detail, htmlFc)                      }},
      prepareAdd:       { start: (detail)=>{  fullcontEntity.prepareAdd(detail, htmlFc)                }},
      prepareEdit:      { start: (detail)=>{  fullcontHandler.prepareEdit(detail, htmlFc)              }},
      saveFromDialog:   { start: (detail)=>{  fullcontEntity.saveFromDialog(detail, htmlFc)            }},
      selectOne:        { start: (detail)=>{  fullcontEntity.selectOne(detail, htmlFc, editSigner(htmlFc))                 }},
      update:           { start: (detail)=>{  fullcontEntity.update(detail, htmlFc, up())              }},
      editSignature:    { start: (detail)=>{  editSignature(detail)                                    }},

}/**/

//function to send
function editSignature(detail){
      signature.start({ act:"edit", id:"warehousepurchase_form_signature", entity:'warehousepurchase', name:settings.getData().name } )
}

function editSigner(htmlFc) {
      setTimeout(() => {
      let signer = htmlFc.fullcontHTML.querySelector('#warehousepurchase_form_signer');
      
      if (!signer) {
          console.log('No se encontró el contenedor del input');
          return;
      }
  
      let input = signer.querySelector('input[type="text"]');
  
      if (!input) {
          console.log('No se encontró el input dentro del contenedor');
          return;
      }

      if(input.value === "") {
          input.value = settings.getData().name; 
          console.log('Se asignó el nombre del usuario a la firma');
      }
        
      }, 800);
  }
  
  

function editDialog(){
            dialog.start({ act:"show", id:"saveChanges", entity:'warehousepurchase' } )
}

function deleteDialog(detail){
            dialog.start({ act:"show",  dest:'warehousepurchase', id:"deleteElem", entity:'warehousepurchase', dbid: detail.dbid } )
}

function dtCall(act, result){ 
      warehousepurchaseDt.start({act:act, row: result})
}

function addOne(detail, htmlFc){

      fullcontEntity.addOne(detail, htmlFc) 
      setTimeout(()=>{
           // gokuDt.start({"dest":"goku", "elem":"dt", "act":"select", "entity":"goku"})  
      },100)  
                   
}

function up(){
      setTimeout(()=>{
            warehousepurchaseDt.start({"dest":"warehousepurchase", "elem":"dt", "act":"select", "entity":"warehousepurchase"})  
      },500) 
}

function deleteFromDialog(detail, htmlFc){

      fullcontEntity.deleteFromDialog(detail, htmlFc) 
      setTimeout(()=>{
            warehousepurchaseDt.start({"dest":"warehousepurchase", "elem":"dt", "act":"select", "entity":"warehousepurchase"})  
      },900)  
                   
}
